import { makeRemoteGetMetersByStatus } from "../../usecases/meter/remote-get-meters-by-status-factory";
import PurchaseRequestLayout from "../../../../presentation/pages/purchaseRequest/electricity/purchaseRequest";

export const makeElectricityPurchaseRequest = () => {
  console.log("makeElectricityPurchaseRequest");
  return (
    <PurchaseRequestLayout getActiveMeters={makeRemoteGetMetersByStatus()} />
  );
};
